import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Table, Typography } from 'antd';
import { useClient } from 'src/contexts/Client/Client';
import * as rolesActions from 'src/actions/rolesActions';
import { filterMembersApiResponse } from '../utils';

import { RoleType } from 'src/types';

import { GroupMemberFiltred, MembersGroupReponseApiType } from '../types';
import { RoleListType } from 'src/reducers/rolesReducer';

type AdministratorListProps = {
  getRoles: () => void;
  groupId: string;
  administratorRoleId: Array<RoleType>;
};

const { Text } = Typography;

const ADMINISTRATOR_PER_PAGE = 10;

const AdministratorList: React.FC<AdministratorListProps> = ({
  getRoles,
  groupId,
  administratorRoleId,
}) => {
  const { get } = useClient();
  const [administrators, setAdministrators] = useState<
    Array<GroupMemberFiltred>
  >([]);
  const [loading, setLoading] = useState(false);
  const [current, setCurrent] = useState<number>(1);
  const [total, setTotal] = useState<number>(1);

  useEffect(() => {
    if (!administratorRoleId) return getRoles();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!administratorRoleId && loading) return;

    setLoading(true);
    get(
      `/groups/${groupId}/members?roles[]=${administratorRoleId}&per_page=${ADMINISTRATOR_PER_PAGE}&page=${current}`,
      (response: MembersGroupReponseApiType) => {
        response.metadata && setTotal(response.metadata.total_count);
        setAdministrators(filterMembersApiResponse(response));
        setLoading(false);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [administratorRoleId, current]);

  const columns = [
    {
      title: 'Nom',
      dataIndex: 'memberInfo',
      render: (member: { lastname: string }) => <Text>{member.lastname}</Text>,
      width: '25%',
    },
    {
      title: 'Prénom',
      dataIndex: 'memberInfo',
      render: (member: { firstname: string }) => (
        <Text>{member.firstname}</Text>
      ),
      width: '25%',
    },
    {
      title: 'Adresse',
      dataIndex: 'memberInfo',
      render: (member: { address: string }) => <Text>{member.address}</Text>,
      width: '40%',
    },
  ];

  return (
    <Table
      key={groupId}
      columns={columns}
      loading={loading}
      dataSource={administrators}
      pagination={{
        current: current,
        total: total,
        pageSize: ADMINISTRATOR_PER_PAGE,
        showSizeChanger: false,
        position: ['bottomCenter'],
      }}
      onChange={(pagination: any) => setCurrent(pagination.current)}
    />
  );
};

const mapStateToProps = ({ roles }: { roles: RoleListType }) => {
  return {
    administratorRoleId: roles.items.filter(
      (role: RoleType) => role.type === 'group' && role.name === 'administrator'
    )[0]?.id,
  };
};

export default connect(mapStateToProps, {
  ...rolesActions,
})(AdministratorList);
